// services/settings/systemSettingsApi.js
import axiosInstance from "../server/axios";

const getAuthHeaders = () => ({
    Authorization: `Bearer ${localStorage.getItem('authToken')}`,
    'Content-Type': 'application/json',
});

export const getSystemSettings = () =>
    axiosInstance.get('/system-settings', { headers: getAuthHeaders() });

export const updateSystemSettings = (data) =>
    axiosInstance.post('/system-settings', data, { headers: getAuthHeaders() });
